
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'redirectLink': {'textDecoration': `none`,},'linkText': {'fontFamily': `'Lato-Regular', sans-serif`,'color': `#ffffff`,},
        
      };
    };
  